import { destroyCookie, setCookie } from "utils/nookies";
import { CookiesConstants, LogoutCookies } from "utils/constants";
import { doRedirect } from "../enhanceContext";
import { NextPageContextEnhanced } from "../../types/page";
import {minimizeUserInfoFields} from "dataLayer/localStorage/localStorageMember";

export async function applySLR(context: NextPageContextEnhanced, cookies) {
  // OTP URl
  // @todo Abdlraheem when working on Admin Login,
  // Revisit this Area
  // if (context.req && context.req.url.includes("/slrOtp/")) {
  //   const path = decodeURIComponent(context.req.url).split("/");
  //   const otp_Code = path[path.length - 1].split("&")[0].toString();
  //   const phone_Number = path[path.length - 2].toString();
  //   const url = context.cookies[CookiesConstants.LAST_VISITED_URL]
  //     ? JSON.parse(context.cookies[CookiesConstants.LAST_VISITED_URL])
  //     : `/${context.lang}?slrSuccess=true&phone_number=${phone_Number}&otp_code=${otp_Code}`;
  //   return doRedirect(context, url, 302, "slrOtpRedirect");
  // }

}
